<div class="row margin-bottom mb24">
  <div class="col">
    <div class="policy-info-content">
      <ul class="txt-center">
        <li>
          <strong>{{ policyHolderName }}</strong>
        </li>
        <li>
          {{ "DATA_OF_BIRTH" | translate }}:&nbsp;<strong>{{
            dateOfBirth | date: "MM/dd/yyyy"
          }}</strong>
        </li>
        <li>
          {{ "ZIP_CODE" | translate }}:&nbsp;<strong>{{ zipCode }}</strong>
        </li>
        <li>
          {{ "POLICY" | translate }}:&nbsp;<strong>{{ policyNumber }}</strong>
        </li>
      </ul>
    </div>
  </div>
</div>
<div>
  <div class="text-center margin-vertical mv24">
    <mapfre-button
      additionalClasses="basic primary large-btn"
      [routerLink]="['/signup']"
    >
      {{ "REVIEW_DETAILS" | translate }}
    </mapfre-button>
  </div>
</div>
<hr class="margin-bottom mb24 margin-top mt24" />
<div class="row">
  <div class="col text-center">
    {{ "INFORMATION_IS_CORRECT" | translate }}
    <p>
      <a
        href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}"
        class="mapfre link blue-link"   [ngClass]="{ 'corporate-red': !isAcmic , 'underline': isAcmic}"
      >
        {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
      </a>
    </p>
  </div>
</div>
